"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.azerbadjanTranslations = void 0;
var _types = require("../../../types");
const azerbadjanTranslations = exports.azerbadjanTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Təəssüf edirik!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Geri',
  [_types.ErrorPageTranslationKey.text]: 'Hazırda səhifəyə daxil olmaq mümkün deyil',
  [_types.ErrorPageTranslationKey.notFound]: 'Təəssüf ki, daxil etdiyiniz ünvan hal-hazırda işləmir',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Çatmağa çalışdığınız səhifə məhdud və bütün kriteriyaları ötürməmişdir.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Zəhmət olmasa Oriflame dəstək komandası ilə e-poçt vasitəsilə əlaqə saxlayın:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Tələb olunan URL rədd edildi!'
};
